import React from "react";
import { brandLogos } from "../../data/mockData";

const LogoMarquee = () => {
  const logos = [...brandLogos, ...brandLogos];

  return (
    <section className="py-14 relative overflow-hidden">
      <div className="max-w-[1200px] mx-auto px-6 mb-6">
        <p className="text-center text-[11px] text-[#4a4a4a] uppercase tracking-[0.25em] font-medium">
          Powering +10,000 Social Ad Teams & Agencies
        </p>
      </div>

      <div className="relative">
        {/* Fade edges */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-[#050505] to-transparent z-10" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-[#050505] to-transparent z-10" />

        {/* Scrolling logos */}
        <div className="flex items-center gap-16 animate-marquee">
          {logos.map((name, i) => (
            <span
              key={i}
              className="text-[#3a3a3a] text-sm font-semibold tracking-wide whitespace-nowrap shrink-0 select-none"
            >
              {name}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LogoMarquee;
